import * as Yup from 'yup';
import {
  Resource, ColumnSet, QueryAction, MutationAction,
} from 'ants/resource';
import moment from 'moment';
import { arrayAsObject, objectAsArray } from 'lib/utils';
import {
  TeamRankingReadQuery,
  TeamRankingSearchQuery,
  TeamRankingDeleteMutation,
  TeamRankingUpdateMutation,
  TeamRankingTopCountsQuery,
  RankingCreateMutation,
} from './query';

export const TeamRankingResource = Resource({
  resourceId: 'TeamRanking',
  name: 'TeamRanking',
  storedId: 'TeamRanking',
  pageKey: 'sports.cricket.TeamRanking',
  columnSets: [
    ColumnSet({
      name: 'ranks',
      shape: Yup.object().shape({
        ranks: Yup.mixed().default([]),
      }),
      viewKey: 'ranks',
    }),
    ColumnSet({
      name: 'updatedDate',
      shape: Yup.object().shape({
        ranking_release_date: Yup.number().nullable().default(null),
        ranking_recorded_date: Yup.number().nullable().default(null),
      }),
      viewKey: 'updated_date',
      historyKey: 'TeamRankingUpdatedDate',
    }),
  ],
  listPrimaryActions: [
    { action: 'update', name: 'Update' },
  ],
  queries: {
    read: QueryAction({
      query: TeamRankingReadQuery,
      resourceNamePath: 'item.name.name',
      responsePath: 'sports_cricket_team_ranking_read',
    }),
    search: QueryAction({
      query: TeamRankingSearchQuery,
      responsePath: 'sports_cricket_team_ranking_search',
    }),
    counts: QueryAction({
      query: TeamRankingTopCountsQuery,
      responsePath: 'sports_cricket_ranking_search.top_counts',
    }),
  },
  mutations: {
    update: MutationAction({
      mutation: TeamRankingUpdateMutation,
      responsePath: 'sports_cricket_team_ranking_update',
      cs: ['ranks', 'updated_date'],
      prepareForEdit(self, resource, data) {
        const resp = self.defaultPrepareForEdit(self, resource, data);
        resp.ranks = arrayAsObject(resp.ranks) || {};
        return resp;
      },
      prepareForSave(self, resource, data) {
        const resp = self.defaultPrepareForSave(self, resource, data);
        resp.ranks = objectAsArray(resp.ranks);
        resp.ranks = resp?.ranks?.filter((r) => r.team && r.team.hashkey);
        resp.ranks = resp.ranks.map((r) => ({
          ...r,
          points: parseFloat(r.points, 2),
          matches: parseInt(r.matches, 10),
        }));
        resp.ranks.sort((a, b) => {
          if (b.points !== a.points) return b.points - a.points;
          return a.matches - b.matches;
        });
        resp.updated_date.ranking_recorded_date = moment().set({
          hour: 0, minute: 0, second: 0, millisecond: 0,
        }).unix();
        if (!resp?.updated_date?.ranking_release_date) {
          resp.updated_date.ranking_release_date = moment().set({
            hour: 0, minute: 0, second: 0, millisecond: 0,
          }).unix();
        }
        let rank = 1;
        for (let i = 0; i < resp.ranks.length; i += 1) {
          if (i > 0) {
            const prev = resp.ranks[i - 1];
            const curr = resp.ranks[i];
            if (curr.points < prev.points
            || (curr.points === prev.points && curr.matches > prev.matches)) {
              rank += 1;
            }
          }
          resp.ranks[i].team = {
            _hashkey: resp.ranks[i].team.hashkey,
          };
          resp.ranks[i].ranking = rank;
          delete resp.ranks[i].position;
          delete resp.ranks[i].changed_by;
        }

        return resp;
      },
    }),
    create: MutationAction({
      mutation: RankingCreateMutation,
      responsePath: 'sports_cricket_team_ranking_create',
    }),
    delete: MutationAction({
      mutation: TeamRankingDeleteMutation,
      responsePath: 'sports_cricket_team_ranking_delete',
    }),
  },
});

export default TeamRankingResource;
